var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        display: "flex",
        "flex-direction": "column",
        "align-items": "flex-end"
      }
    },
    [
      _c(
        "div",
        { staticClass: "d-flex" },
        [
          _vm.isTaskBlocked
            ? _c("management-button", {
                staticClass: "map-button",
                attrs: { type: "execute", label: _vm.$t("Show Message") },
                on: { buttonClick: _vm.showErrorMsg }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.taskDecisionButtons || _vm.isTaskBlocked
            ? _c("management-button", {
                staticClass: "map-button",
                attrs: {
                  type: "execute",
                  label: _vm.$t("Submit"),
                  disabled: _vm.taskDecisionButtons
                    ? _vm.taskContents.length !== _vm.list.length
                    : !(_vm.taskContents.length > 0)
                },
                on: { buttonClick: _vm.submit }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("v-data-table", {
        staticClass: "elevation-2",
        style: [
          _vm.taskDecisionButtons
            ? { "margin-top": "10px" }
            : { "margin-top": "0" }
        ],
        attrs: {
          headers: _vm.headers,
          items: _vm.list,
          "items-per-page-text": _vm.rowsPerPageText,
          "items-per-page-items": _vm.allRows
            ? _vm.allRows
            : _vm.rowsPerPageItems,
          "no-data-text": _vm.$t("AddToTable"),
          "header-props": { sortIcon: _vm.sortIcon },
          "footer-props": { prevIcon: _vm.prevIcon, nextIcon: _vm.nextIcon }
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(props) {
              return [
                _c(
                  "tr",
                  {
                    on: {
                      click: function($event) {
                        return _vm.showDialog(props.item.type, props.item)
                      }
                    }
                  },
                  [
                    _c(
                      "td",
                      { staticClass: "text-xs-left" },
                      [
                        props.item.blocked
                          ? _c("v-icon", { attrs: { color: "error" } }, [
                              _vm._v(
                                "\n                    priority_high\n                "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(
                          "\n                " +
                            _vm._s(props.item.label) +
                            "\n            "
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-xs-left" }, [
                      _vm._v(_vm._s(props.item.type))
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-xs-left" }, [
                      _vm._v(_vm._s(props.item.required ? "True" : "False"))
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-xs-left" }, [
                      _vm._v(_vm._s(Number(props.item.index)))
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-xs-left" }, [
                      _vm._v(
                        _vm._s(
                          _vm.checkStepValue(props.item.type, props.item.value)
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "text-xs-left" },
                      [
                        !_vm.editionDisabled
                          ? _c("app-datatable-action-buttons", {
                              attrs: {
                                "user-can-edit": true,
                                "user-can-delete": true
                              },
                              on: {
                                edit: function($event) {
                                  return _vm.$emit("editItem", props.item)
                                },
                                delete: function($event) {
                                  return _vm.$emit("removeItem", props.item)
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.taskManagement
                      ? _c(
                          "td",
                          [
                            _vm.taskDecisionButtons || _vm.isTaskBlocked
                              ? _c("task-decision-buttons", {
                                  attrs: {
                                    isTaskBlocked: _vm.isTaskBlocked,
                                    uuid: props.item.uuid,
                                    taskContents: _vm.taskContents
                                  },
                                  on: {
                                    approve: function($event) {
                                      return _vm.$emit("updateTaskContents", {
                                        decision: "approve",
                                        uuid: props.item.uuid
                                      })
                                    },
                                    reject: function($event) {
                                      return _vm.$emit("updateTaskContents", {
                                        decision: "reject",
                                        uuid: props.item.uuid
                                      })
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                )
              ]
            }
          },
          {
            key: "pageText",
            fn: function(props) {
              return [
                _vm._v(
                  "\n            " +
                    _vm._s(props.pageStart) +
                    " - " +
                    _vm._s(props.pageStop) +
                    " " +
                    _vm._s(_vm.$t("tables.Of")) +
                    "\n            " +
                    _vm._s(props.itemsLength) +
                    "\n        "
                )
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("photo-view", {
        attrs: {
          dialog: _vm.photoDialog,
          imageData: _vm.dialogData,
          taskContents: _vm.taskContents,
          taskDecisionButtons: !_vm.taskDecisionButtons
        },
        on: {
          close: function($event) {
            return _vm.closeImageView($event)
          },
          updateTaskContents: function($event) {
            return _vm.$emit("updateTaskContents", $event)
          }
        }
      }),
      _vm._v(" "),
      _c("text-message", {
        attrs: { textDialog: _vm.textDialog, text: _vm.textMsg },
        on: { closeTextDialog: _vm.closeTextDialog }
      }),
      _vm._v(" "),
      _c(
        "app-dialog-box",
        {
          attrs: {
            open: _vm.rejectDialog,
            title: _vm.$t("RejectTask"),
            content: _vm.$t("RejectionMessage") + "*",
            "main-action-label": _vm.$t("Cancel"),
            "secondary-action-label": _vm.$t("Reject"),
            "secondary-action-disable":
              _vm.rejectionMessage.trim().length !== 0,
            loading: _vm.loadingDelete
          },
          on: {
            mainAction: _vm.cancelRejection,
            secondaryAction: _vm.rejectTask
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "rejection-message-textarea",
              attrs: { slot: "dialog-textbox" },
              slot: "dialog-textbox"
            },
            [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.rejectionMessage,
                    expression: "rejectionMessage"
                  }
                ],
                staticClass: "input-field",
                attrs: { maxlength: "1024" },
                domProps: { value: _vm.rejectionMessage },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.rejectionMessage = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("label", [_vm._v(_vm._s(_vm.$t("RejectionNote")))])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ce098546", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce098546","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Activities/TaskTypes/Mixed/MixedTable.vue
// module id = null
// module chunks = 